// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
var $ = require('jquery');
window.$ = $;


// 引入页面引导
import intro from 'intro.js' // introjs库
import Vue from 'vue';
import App from './App';
import router from './router';
import store from '@/store';
import VueResource from 'vue-resource';
import Vant from 'vant';
import 'vant/lib/index.css';
import "amfe-flexible/index"
import { Lazyload, Toast } from 'vant';
import Navigation from 'vue-navigation';
import directive from '@/utils/directive.js';
import VueClipboard from 'vue-clipboard2'

import moment from 'moment'//导入文件
Vue.prototype.$moment = moment;//赋值使用
moment.locale('zh-cn');//需要汉化

import VConsole from 'vconsole';
// new VConsole()

import 'intro.js/introjs.css' // introjs默认css样式
// introjs还提供了多种主题，可以通过以下方式引入
import 'intro.js/themes/introjs-modern.css' // introjs主题
// 加到prototype中，直接通过vue实例就能调用intro了

import loadSdk from '@/utils/newJtjssdk/jingtongsdk.js'

Vue.prototype.$loadSdk = loadSdk
Toast.setDefaultOptions({ duration: 3000 }); // 统一设置全局的Toast组件默认显示时间为3秒
import BaseComponent from '@/components/base'
Vue.use(BaseComponent, {})
Vue.use(Navigation, { router })
Vue.use(Vant);
Vue.use(Toast);
Vue.use(Lazyload);
Vue.use(VueResource);
Vue.use(VueClipboard);
Vue.prototype.$intro = new intro();
const formatNumber = (n) => {
  return (n || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}
// 数字千分符
Vue.filter('formatNumber', formatNumber)
Vue.prototype.$formatNumber = formatNumber

//自定义指令
for (let key in directive) {
  Vue.directive(key, directive[key])
}

Vue.config.productionTip = false

/* eslint-disable no-new */
window.vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
router.afterEach(r => {
  if (r.meta.keepAlive) return;
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/main.js